import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { catchError, finalize, throwError } from 'rxjs';
import { AppService } from '../app.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {

  const authService = inject(AuthService);
  const appService = inject(AppService);
  const token = authService.getCookie('user_data');
  appService.loader.set(true);

  if (token && !req.url.includes('region-and-province')) {
    const parse = JSON.parse(token)?.token;
    const cloneReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + parse)
    })

    return next(cloneReq).pipe(
      catchError((err) => {
        if (err.status === 401) {
          authService.logout();
        }
        let error = err.error.message || err.statusText;
        if (err.error.errors && err.error.errors.length > 0) {
          error = {
            message: error,
            errors: err.error.errors,
          };
        }
        return throwError(() => new Error(error));
      }),
      finalize(() => appService.loader.set(false))
    )
  }

  return next(req).pipe(
    finalize(() => appService.loader.set(false))
  );
}